export default __webpack_public_path__ + "static/media/039-father.7923088d.png";